<bfx-close></bfx-close>
<div class="auth__login__panel" nativeDesktopClass="desktop">
  <div fxLayout="row" fxLayoutAlign="space-around start" class="auth__login__panel__header">
    <div fxFlex="50" class="auth__login__panel__header-logo">
      <bfx-logo-svg></bfx-logo-svg>
    </div>
    <div fxFlex="50" class="auth__login__panel__header-title">{{ frameTag }}</div>
  </div>
  <div class="auth__login__panel__body">
    <div class="auth__login__form">
      <div class="reset-pasword-sucess">
        <label *ngIf="newPasswordSuccess">Password Updated</label>
      </div>
      <div style="clear: both"></div>
      <div class="reset-password-divider">
        Your password has expired or been reset. Please enter a new password.
      </div>
      <form class="auth__login__form">
        <input type="text" autocomplete="username" hidden />

        <div class="auth__login__form__group">
          <label
            for="oldPassword-input"
            class="auth__login__form__label"
            [ngClass]="{ 'non-empty': oldPassword.length > 0 }"
            >Old Password</label
          >
          <input
            id="oldPassword-input"
            name="oldPassword-input"
            pInputText
            [ngClass]="{
              valid: validPasswordField[0] === true,
              invalid: validPasswordField[0] === false,
            }"
            [(ngModel)]="oldPassword"
            type="password"
            maxlength="maxPasswordLength"
            (focus)="$event.target.select()"
            (blur)="validatePasswordField(0)"
            (ngModelChange)="validatePasswordField(0)"
            [disabled]="changePasswordSubmitted"
            spellcheck="false"
            class="auth__login__form__input"
            type="password"
            autocomplete="new-password"
            data-msg-required="Please enter your old password."
            required=""
            aria-required="true"
            (keyup.enter)="changePassword()"
          />
          <div class="reset-password-error-messages">{{ passwordErrors[0] }}</div>
        </div>
        <div class="auth__login__form__group">
          <label
            for="newPassword-input"
            class="auth__login__form__label"
            [ngClass]="{ 'non-empty': newPassword.length > 0 }"
            >New Password</label
          >
          <input
            id="newPassword-input"
            name="newPassword-input"
            pInputText
            [ngClass]="{
              valid: validPasswordField[1] === true,
              invalid: validPasswordField[1] === false,
            }"
            [(ngModel)]="newPassword"
            type="password"
            maxlength="maxPasswordLength"
            (focus)="$event.target.select()"
            (blur)="validatePasswordField(1)"
            (ngModelChange)="validatePasswordField(1)"
            [disabled]="changePasswordSubmitted"
            spellcheck="false"
            class="auth__login__form__input"
            autocomplete="new-password"
            data-msg-required="Please enter your old password."
            required=""
            aria-required="true"
            (keyup.enter)="changePassword()"
          />
          <div class="reset-password-error-messages">{{ passwordErrors[1] }}</div>
        </div>
        <div class="auth__login__form__group">
          <label
            for="newPasswordConfirmation-input"
            class="auth__login__form__label"
            [ngClass]="{ 'non-empty': newPasswordConfirmation.length > 0 }"
            >Confirm New Password</label
          >
          <input
            id="newPasswordConfirmation-input"
            name="newPasswordConfirmation-input"
            pInputText
            [ngClass]="{
              valid: validPasswordField[2] === true,
              invalid: validPasswordField[2] === false,
            }"
            [(ngModel)]="newPasswordConfirmation"
            type="password"
            maxlength="maxPasswordLength"
            (focus)="$event.target.select()"
            (blur)="validatePasswordField(2)"
            (ngModelChange)="validatePasswordField(2)"
            [disabled]="changePasswordSubmitted"
            spellcheck="false"
            class="auth__login__form__input"
            autocomplete="new-password"
            data-msg-required="Please enter your old password."
            required=""
            aria-required="true"
            (keyup.enter)="changePassword()"
          />
          <div class="reset-password-error-messages">{{ passwordErrors[2] }}</div>
          <div class="message general_error">{{ generalPasswordError }}</div>
        </div>
        <div class="change-password-entry">
          <div class="reset-password-progress-bar-container">
            <div
              [style.width.%]="(newPasswordStrength / 4) * 100"
              [class]="'progress-bar-value ' + newPasswordStrengthColor"
            ></div>
          </div>
          <div class="reset-password-error-messages">
            {{ newPasswordStrengthMessage }}
          </div>
        </div>
        <div class="change-password-entry set-password-buttons-panel">
          <span>
            <button
              class="set-password-btn bfx-button-primary"
              [disabled]="changePasswordSubmitted"
              (click)="cancelChangePassword()"
            >
              Cancel
            </button>
            <button
              class="set-password-btn bfx-button-positive"
              [disabled]="savePasswordDisabled || changePasswordSubmitted"
              (click)="changePassword()"
            >
              Set Password
            </button>
          </span>
        </div>
      </form>
    </div>
  </div>
  <div class="auth__login__panel__footer">
    <p class="copyright">&copy; BarracudaFX</p>
  </div>
</div>
